
export class SearchBase<T> {
  items?: T[];
  pageNumber: number;
  pageSize: number;
  totalItemsCount: number;
  isExport: boolean = false;
  isShowWillExpire?: boolean ;
  exportTypeId: ExportType = ExportType.Xlsx;
  orderBy?: number;
  orderByColumn?: string;
}
export enum ExportType {
  Xlsx = 1,
  Pdf = 2,
  Csv = 3
}
